import {AxiosResponse} from "axios";
import {ApiBase} from "./ApiBase";
import {IApiResult} from "./AxiosWealthManagementApi";

export interface AdminRegion {
    id: number;
    regionName: string;
    isDefault: boolean;
    languageCode: string | null;
    parentRegionId: number | null;
    published: boolean;
    stats: Stat[];
    servicePills?: ServicePill[];
}

export interface CreateRegionRequest {
    regionName: string;
    parentRegionId?: number;
    languageCode?: string;
}

export interface Stat {
    value: string;
    label: string;
}

export interface ServicePill {
    label: string;
    url: string;
}

export class LoginContentAdminApi {
    public static getRegions(): Promise<AdminRegion[]> {
        return ApiBase.processGetUnwrapped(
            "/login-content/admin/regions",
            (response: AxiosResponse): AdminRegion[] => {
                return (response.data as AdminRegion[]);
            });
    }

    static createRegion(request: CreateRegionRequest): Promise<IApiResult<AdminRegion>> {
        return ApiBase.processPostWithResponseBody(
            "/login-content/admin/regions",
            request,
            (response: AxiosResponse) => {return response.data;}
        );
    }

    static deleteRegion(id: number) {
        return ApiBase.processDelete(`/login-content/admin/regions/${id}`);
    }

    static saveStats(regionId: number, stats: Stat[]) {
        return ApiBase.processPost(`/login-content/admin/regions/${regionId}/stats`, stats);
    }

    static savePills(regionId: number, pills: ServicePill[]) {
        return ApiBase.processPost(`/login-content/admin/regions/${regionId}/pills`, pills);
    }
}
